
import { cloneDeep, difference } from 'lodash';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { NButton } from '@/uikit';
import NButtonGroup from '@/uikit/buttons/NButtonGroup.vue';
import NForm, { IFormLayout } from '@/uikit/forms/NForm.vue';
import NModalWindow from '@/uikit/modal-window/NModalWindow.vue';
import FiltersBig from '@/components/common/filter/FiltersBig.vue';
import FiltersSmall from '@/components/common/filter/FiltersSmall.vue';
import { EditorSection, EditorSections } from '@/pages/webhooks/components/types';
import { isSectionAvailable, isSectionIncludedInArrayBuilder } from '@/pages/webhooks/components/utils';
import WebhooksFiltersDivider from '@/pages/webhooks/components/WebhooksFiltersDivider.vue';
import {dialogModule} from "@/store/dialogs/dialogModule";

@Options({
  name: 'WebhooksFiltersEditorVisual',
  components: { FiltersBig, FiltersSmall, NButton, NButtonGroup, NForm, NModalWindow, WebhooksFiltersDivider },
  emits: ['reset', 'close', 'update:modelValue']
})
export default class WebhooksFiltersEditorVisual extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly modelValue!: Record<string, any>;

  @Prop({ type: Object, required: true })
  readonly formLayout!: Record<EditorSection, IFormLayout>;

  @Prop({ type: Array })
  readonly sections?: EditorSection[];

  @Prop({ type: Boolean, default: true })
  multiple = true;

  private model: Record<string, any> = {};

  get activeSections() {
    return Object.keys(this.model).filter(isSectionIncludedInArrayBuilder(this.sections)).filter(isSectionAvailable);
  }

  get sectionItems() {
    return Object.values(EditorSections)
      .filter(isSectionAvailable)
      .filter(isSectionIncludedInArrayBuilder(this.sections))
      .map((v) => {
        return {
          value: v,
          label: this.$t(`webhooks.section_${v}`, 'f')
        };
      });
  }

  @Watch('modelValue', { deep: true, immediate: true })
  syncModelValue() {
    this.model = cloneDeep(this.modelValue);
  }

  async toggleActiveSection(sections: EditorSection[]) {
    const [sectionOff] = difference(this.activeSections, sections);
    const [sectionOn] = difference(sections, this.activeSections);
    const hasActiveSection = !!Object.keys(this.model).length;

    if (sectionOff) delete this.model[sectionOff];
    if (sectionOn) {
      if (!this.multiple && hasActiveSection) {
        const result = await dialogModule.createResetAlertRulesConfirm();
        if (!result) return;
        Object.keys(this.model).forEach((key) => delete this.model[key]);
      }
      this.model[sectionOn] = {};
    }
  }

  submit() {
    this.$emit('update:modelValue', this.model);
    this.$emit('close');
  }

  resetSection(v: EditorSection) {
    this.model[v] = {};
  }
}
